export default __webpack_public_path__ + "static/media/IMG-20241005-WA0022.fd0c9bc3.jpg";